<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else class="py-2 pr-2 h-100" id="dashboard-bar-chart">
    <div class="pl-3">
      <div class="d-flex justify-content-between">
        <div class="card-content-title-wrp">
          <div class="content-name text-collapse">
            {{
              renderData.jsonOverride.Left_Title
                ? renderData.jsonOverride.Left_Title
                : config.config.left_title
            }}
          </div>
          <div
            class="content-value"
            v-if="
              renderData.jsonOverride.Button_Left_Title ||
              config.config.button_left_title
            "
          >
            <span>
              {{
                renderData.jsonOverride.Button_Left_Title
                  ? renderData.jsonOverride.Button_Left_Title
                  : config.config.button_left_title
              }}</span
            >
            <span> คำตอบ</span>
          </div>
        </div>
        <div
          class="content-type d-flex justify-content-end"
          v-if="
            renderData.jsonOverride.Right_Title || config.config.right_title
          "
        >
          <div class="d-flex justify-content-between content-type-wrp">
            <div
              :class="
                layoutData.module_name == 'SurveyDashboard' ? 'border-type' : ''
              "
            >
              Type :
            </div>
            <div class="d-flex ml-2">
              <div class="mr-1 icon-type-svg">
                <component
                  :is="
                    resovleIcon(
                      renderData.jsonOverride.Right_Title
                        ? renderData.jsonOverride.Right_Title
                        : config.config.right_title
                    )
                  "
                  class="mr-2"
                />
              </div>
              <div>
                {{
                  renderData.jsonOverride.Right_Title
                    ? renderData.jsonOverride.Right_Title
                    : config.config.right_title
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <div
            class="content-title"
            v-if="layoutData.module_name == 'QuizDashboard'"
          >
            จำนวนลูกค้าทั้งหมด
          </div>
          <div v-if="renderData.data.length > 0">
            <v-chart
              ref="chartBar"
              class="chart-customer"
              :option="option"
              autoresize
            />
          </div>
          <div class="legend-wrp mt-2">
            <div v-for="item in renderData.legend" :key="item.title">
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center ml-3">
                    <div
                      class="legend-radius-color"
                      :style="{ backgroundColor: item.color }"
                    />
                    <div class="legend-title">
                      {{ item.title }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";

import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import MultipleChoiceSvg from "@/@core/components/svg/survey/MultipleChoice.vue";
import TextAreaSvg from "@/@core/components/svg/survey/TextArea.vue";
import DateSvg from "@/@core/components/svg/survey/Date.vue";
import DropdownSvg from "@/@core/components/svg/survey/Dropdown.vue";

import quizListModel from "@/models/survey-quiz/quiz-list";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent,
  DatasetComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent,
  BarChart,
  DatasetComponent,
]);

export default {
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  components: {
    VChart,
    SingleChoiceSvg,
    MultipleChoiceSvg,
    TextAreaSvg,
    DateSvg,
    DropdownSvg,
  },
  setup(props) {
    const { fetchQueryDataDashboard } = quizListModel();

    const { fetchQueryDataDashboard: fetchQueryDataSurveyDashboard } =
      surveyModel();

    const { openDefaultErrorModal } = useValidationModal();

    const loading = reactive({
      Data: false,
    });

    const formData = reactive({
      groupId: "",
      moduleName: "",
    });

    const palette = reactive({
      QuizDashboard: ["#67AD5B", "#C6C6C6"],
      SurveyDashboard: [
        "#FD6383",
        "#FECC55",
        "#4CBFBE",
        "#35A3EB",
        "#9277FF",
        "#D4D4D4",
      ],
    });

    const MODULENAME = reactive({
      QUIZ: "QuizDashboard",
      SURVEY: "SurveyDashboard",
    });

    const resolveChartModule = (moduleName, GroupId) => {
      switch (moduleName) {
        case MODULENAME.QUIZ:
          fetchDashboradDetail(GroupId);
          return;
        case MODULENAME.SURVEY:
          fetchDashboradSurveyDetail(GroupId);
          return;
      }
    };

    const option = reactive({
      color: palette[props.layoutData.module_name], // Global palette chart
      tooltip: {
        trigger: "item",
        position: "right",
        formatter: function (data) {
          if (data.data.image) {
            return `<div class="tooltip-wrp" >
           <img src="${data.data.image}" class="w-100 tooltip-image"></div>`;
          }
        },
        borderColor: "#fff",
        borderRadius: 10,
        padding: 3,
      },
      yAxis: {
        type: "category",
        data: [],
        axisTick: {
          show: false, //ขีดแบ่ง data
        },
        inverse: true, //สลับตำแหน่ง data
        axisLine: {
          show: true,
          lineStyle: {
            color: "#EAEAEA",
            height: "300px",
          },
        }, //แกนหลัก
        axisLabel: {
          // lable แกนหลัก
          color: "#000000",
        },
      },
      xAxis: {
        type: "value",
        splitLine: { show: false }, //line in bar
        axisLine: {
          show: true,
          lineStyle: {
            color: "#EAEAEA",
          },
        }, //แกนหลัก
        axisLabel: {
          // lable แกนหลัก
          color: "#000000",
        },
        // min: 0,
        // max: 250,
      },
      grid: {
        left: "3%",
        right: "15%",
        bottom: "10%",
        containLabel: true,
      },

      series: [
        {
          type: "bar",
          itemStyle: {
            borderRadius: [0, 10, 10, 0], //[topLeft, topRight, bottomRight, bottomLeft]
          },
          barWidth: "90%",

          label: {
            show: true,
            position: "right",
            formatter: function (data) {
              return `${data.value} (${data.data.percent})`;
            },
          },
          data: [],
        },
      ],
    });

    const renderData = reactive({
      data: [],
      legend: [],
      jsonOverride: null,
    });

    const fetchDashboradDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Quiz_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataDashboard)
        .then((response) => {
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          response.data.list.map((o) => {
            renderData.data.push({
              value: o.value,
              name: o.name,
              image: o.image,
              percent: o.percent,
              itemStyle: {
                color: o.is_correct == "True" ? "#67AD5B" : "#C6C6C6",
              },
            });

            option.series[0].data = renderData.data;
          });

          response.data.list.map((o) => {
            option.yAxis.data.push(o.name);
          });

          renderData.legend = [
            {
              title: "ถูก",
              color: "#67AD5B",
            },
            {
              title: "ผิด",
              color: "#C6C6C6",
            },
          ];
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resolveColor = (index) => {
      switch (index) {
        case 0:
          return "#FD6383";
        case 1:
          return "#FECC55";
        case 2:
          return "#4CBFBE";
        case 3:
          return "#35A3EB";
        case 4:
          return "#9277FF";
        case 5:
          return "#D4D4D4";
      }
    };

    const fetchDashboradSurveyDetail = (GoupId) => {
      loading.Data = true;
      const payload = {
        CardId: props.config.id,
        Survey_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataSurveyDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataSurveyDashboard)
        .then((response) => {
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          response.data.list.map((o, index) => {
            renderData.data.push({
              value: o.value,
              name: o.name,
              image: o.image,
              percent: o.percent,
              itemStyle: {
                color: resolveColor(index),
              },
            });

            option.series[0].data = renderData.data;
          });

          response.data.list.map((o) => {
            option.yAxis.data.push(o.name);
          });
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resovleIcon = (iconName) => {
      switch (iconName) {
        case "Single Choice":
          return "SingleChoiceSvg";
        case "Multiple Choice":
          return "MultipleChoiceSvg";
        case "Dropdown":
          return "DropdownSvg";
        case "Date":
          return "DateSvg";
        case "Text Area":
          return "TextAreaSvg";
      }
    };

    onBeforeMount(() => {
      formData.groupId = parseInt(router.currentRoute.params.ref);
      formData.moduleName = props.layoutData.module_name;

      resolveChartModule(formData.moduleName, formData.groupId);
    });

    return { loading, option, renderData, resovleIcon };
  },
};
</script>

<style>
#dashboard-bar-chart .tooltip-wrp {
  width: 100px !important;
  height: auto !important;
}

#dashboard-bar-chart .tooltip-image {
  border-radius: 10px;
}

#dashboard-bar-chart .icon-type-svg > svg {
  fill: #a2a2a2 !important;
  stroke: #a2a2a2 !important;
  width: 15px !important;
  height: 15px !important;
  margin-bottom: 1px;
}

#dashboard-bar-chart g#Rectangle_11537 {
  stroke: #a2a2a2 !important;
}
</style>

<style scoped>
#dashboard-bar-chart .chart-customer {
  width: 100%;
  height: 300px;
}

#dashboard-bar-chart .card-content-title-wrp {
  min-height: 70px;
}

#dashboard-bar-chart .text-collapse {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

#dashboard-bar-chart .content-name {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

#dashboard-bar-chart .content-value {
  font-size: 18px;
  padding-left: 16px;
  color: #707070;
}

#dashboard-bar-chart .content-title {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  padding-left: 16px;
}

#dashboard-bar-chart .content-type {
  font-size: 18px;
  color: #707070;
}

#dashboard-bar-chart .content-type-wrp {
  width: 163px;
}

#dashboard-bar-chart .legend-wrp {
  position: absolute;
  bottom: 0;
  right: 44%;
  display: flex;
}

#dashboard-bar-chart .legend-radius-color {
  margin-right: 10px;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}

#dashboard-bar-chart .legend-title {
  font-size: 18px;
  color: #000;
}

#dashboard-bar-chart .border-type {
  border-left: 1.5px solid #a2a2a2;
  height: 30px;
  padding-left: 10px;
}
</style>